var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { API_V1_PATH } from "@/06-shared/api/request/config";
import { request } from "@/06-shared/api/request";
const AUTH_API_PATH = `${API_V1_PATH}/auth`;
const jsonHeaders = {
    "Content-Type": "application/json",
};
export const login = (payload) => __awaiter(void 0, void 0, void 0, function* () {
    yield request(`${AUTH_API_PATH}/login`, {
        method: "POST",
        headers: jsonHeaders,
        body: JSON.stringify(payload),
    });
});
export const register = (payload) => __awaiter(void 0, void 0, void 0, function* () {
    yield request(`${AUTH_API_PATH}/register`, {
        method: "POST",
        headers: jsonHeaders,
        body: JSON.stringify(payload),
    });
});
export const validateSession = () => __awaiter(void 0, void 0, void 0, function* () {
    yield request(`${AUTH_API_PATH}/validate`, { method: "POST" });
});
export const logout = () => __awaiter(void 0, void 0, void 0, function* () {
    yield request(`${AUTH_API_PATH}/logout`, { method: "POST" });
});
